<template>
    <v-list>
        <v-list-item v-for="(option, idx) in options" :key="idx">
            <SoliAvatarBtn
                :title="option.title"
                @click="$emit('input', option.value)"
                :icon="option.icon"
                blue
                :disabled="option.disabled"
                :subtitleBottom="option.subtitleBottom"
            ></SoliAvatarBtn>
        </v-list-item>
    </v-list>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {};
    },
};
</script>
